let paymentRequestIcon = `<svg width="25" height="22" viewBox="0 0 25 22" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M15.0586 1.40068C15.0211 1.36317 14.9702 1.3421 14.9172 1.3421H7C5.9 1.3421 5 2.2421 5 3.3421V19.3421C5 20.4421 5.9 21.3421 7 21.3421H19C20.1 21.3421 21 20.4421 21 19.3421V7.42494C21 7.3719 20.9789 7.32103 20.9414 7.28352L15.0586 1.40068ZM7.2 19.3421C7.08954 19.3421 7 19.2526 7 19.1421V3.5421C7 3.43164 7.08954 3.3421 7.2 3.3421H13.8C13.9105 3.3421 14 3.43165 14 3.5421V7.1421C14 7.25256 14.0895 7.3421 14.2 7.3421H18.8C18.9105 7.3421 19 7.43164 19 7.5421V19.1421C19 19.2526 18.9105 19.3421 18.8 19.3421H7.2Z" fill="#BDBDBD"/>
<path d="M12.9092 9.3421V16.3421" stroke="#BDBDBD" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M14.5 10.6149H12.1136C11.8183 10.6149 11.535 10.7322 11.3262 10.941C11.1173 11.1499 11 11.4331 11 11.7285C11 12.0239 11.1173 12.3071 11.3262 12.516C11.535 12.7248 11.8183 12.8421 12.1136 12.8421H13.7045C13.9999 12.8421 14.2832 12.9595 14.492 13.1683C14.7009 13.3772 14.8182 13.6604 14.8182 13.9558C14.8182 14.2511 14.7009 14.5344 14.492 14.7432C14.2832 14.9521 13.9999 15.0694 13.7045 15.0694H11" stroke="#BDBDBD" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;

let hostedPaymentPgeIcon = `<svg width="23" height="20" viewBox="0 0 23 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10.3332 15.4671C10.4943 15.4671 10.6248 15.3365 10.6248 15.1755C10.6248 15.0144 10.4943 14.8838 10.3332 14.8838C10.1721 14.8838 10.0415 15.0144 10.0415 15.1755C10.0415 15.3365 10.1721 15.4671 10.3332 15.4671Z" stroke="#BDBDBD" stroke-width="0.583333" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M13.5417 15.4671C13.7028 15.4671 13.8333 15.3365 13.8333 15.1755C13.8333 15.0144 13.7028 14.8838 13.5417 14.8838C13.3806 14.8838 13.25 15.0144 13.25 15.1755C13.25 15.3365 13.3806 15.4671 13.5417 15.4671Z" stroke="#BDBDBD" stroke-width="0.583333" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M8 9.3421H9.16667L9.94833 13.2475C9.975 13.3818 10.0481 13.5024 10.1547 13.5883C10.2613 13.6741 10.3948 13.7197 10.5317 13.7171H13.3667C13.5035 13.7197 13.637 13.6741 13.7436 13.5883C13.8503 13.5024 13.9233 13.3818 13.95 13.2475L14.4167 10.8004H9.45833" stroke="#BDBDBD" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
<rect x="1" y="3.85092" width="21" height="14.8912" rx="1" stroke="#BDBDBD" stroke-width="2"/>
<path d="M2 1.3421H21C21.5523 1.3421 22 1.78982 22 2.3421V6.20721H1V2.3421C1 1.78982 1.44772 1.3421 2 1.3421Z" fill="white"/>
<line x1="3.98074" y1="3.64829" x2="6.00269" y2="3.64829" stroke="#BDBDBD" stroke-width="1.26372" stroke-linecap="round"/>
<line x1="8.53018" y1="3.64829" x2="19.0191" y2="3.64829" stroke="#BDBDBD" stroke-width="1.26372" stroke-linecap="round"/>
<path d="M2 1.3421H21C21.5523 1.3421 22 1.78982 22 2.3421V6.20721H1V2.3421C1 1.78982 1.44772 1.3421 2 1.3421Z" stroke="#BDBDBD" stroke-width="2"/>
</svg>
`;

let accessPermissionCardIcon = `<svg width="23" height="20" viewBox="0 0 23 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M22.034 14.5876C22.034 14.3635 22.0035 14.1599 21.9729 13.946L22.8283 13.2026C23.0116 13.0397 23.0523 12.7749 22.9301 12.5611L22.3293 11.5224C22.2071 11.3085 21.9526 11.2169 21.7285 11.2984L20.6491 11.665C20.3232 11.39 19.9566 11.1762 19.5493 11.0234L19.3253 9.91343C19.2743 9.67922 19.0707 9.5061 18.8263 9.5061H17.6246C17.3802 9.5061 17.1766 9.67922 17.1257 9.91343L16.9016 11.0234C16.4943 11.1762 16.1277 11.39 15.8018 11.665L14.7224 11.2984C14.4882 11.2169 14.2438 11.3187 14.1216 11.5224L13.5208 12.5611C13.3986 12.7749 13.4393 13.0397 13.6226 13.2026L14.478 13.946C14.4474 14.1599 14.4169 14.3635 14.4169 14.5876C14.4169 14.8116 14.4474 15.0153 14.478 15.2291L13.6226 15.9725C13.4393 16.1354 13.3986 16.4002 13.5208 16.6141L14.1216 17.6528C14.2438 17.8666 14.4984 17.9583 14.7224 17.8768L15.8018 17.5102C16.1277 17.7851 16.4943 17.999 16.9016 18.1517L17.1257 19.2617C17.1766 19.4959 17.3802 19.6691 17.6246 19.6691H18.8263C19.0707 19.6691 19.2743 19.4959 19.3253 19.2617L19.5493 18.1517C19.9566 17.999 20.3232 17.7851 20.6491 17.5102L21.7285 17.8768C21.9627 17.9583 22.2071 17.8564 22.3293 17.6528L22.9301 16.6141C23.0523 16.4002 23.0116 16.1354 22.8283 15.9725L21.9729 15.2291C22.0035 15.0153 22.034 14.8116 22.034 14.5876ZM18.2153 16.6242C17.0951 16.6242 16.1786 15.7077 16.1786 14.5876C16.1786 13.4674 17.0951 12.5509 18.2153 12.5509C19.3354 12.5509 20.2519 13.4674 20.2519 14.5876C20.2519 15.7077 19.3354 16.6242 18.2153 16.6242ZM14.1419 8.74235V3.38593H17.1969V7.45926H19.2336V2.3676C19.2336 1.80751 18.7754 1.34926 18.2153 1.34926H14.1419C14.1419 0.789182 13.6837 0.330933 13.1236 0.330933H3.055C2.49491 0.330933 2.03666 0.789182 2.03666 1.34926V16.6242H1.01833C0.458249 16.6242 0 17.0825 0 17.6426C0 18.2027 0.458249 18.6609 1.01833 18.6609H12.37C11.5656 17.5102 11.087 16.1049 11.087 14.5876C11.087 12.1639 12.2988 10.0356 14.1419 8.74235ZM3.87759 2.18002H12.37V8.30829C12.37 8.30829 10.6194 9.91343 9.99254 12.0815C9.36567 14.2496 9.99254 16.6263 9.99254 16.6263L3.87759 16.6242V2.18002Z" fill="#BDBDBD"/>
</svg>
`;
let brandingStyleIcon = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3.3889 19.6724L4.6753 20.21V11.5412L2.3425 17.1668C1.9489 18.146 2.4193 19.2692 3.3889 19.6724ZM22.1089 16.1204L17.3473 4.62922C17.0497 3.90922 16.3489 3.46762 15.6097 3.44842C15.3601 3.44842 15.1009 3.48682 14.8513 3.59242L7.7761 6.52042C7.0561 6.81802 6.6145 7.50922 6.5953 8.24842C6.5857 8.50762 6.6337 8.76682 6.73931 9.01642L11.5009 20.5076C11.7985 21.2372 12.5089 21.6788 13.2577 21.6884C13.5073 21.6884 13.7569 21.6404 13.9969 21.5444L21.0625 18.6164C22.0417 18.2132 22.5121 17.09 22.1089 16.1204ZM13.2769 19.7684L8.5153 8.28682L15.5713 5.36842H15.5809L20.3329 16.8404L13.2769 19.7684Z" fill="#BDBDBD"/>
<path d="M11.5199 10.4084C12.0501 10.4084 12.4799 9.97861 12.4799 9.44842C12.4799 8.91823 12.0501 8.48842 11.5199 8.48842C10.9897 8.48842 10.5599 8.91823 10.5599 9.44842C10.5599 9.97861 10.9897 10.4084 11.5199 10.4084Z" fill="#BDBDBD"/>
<path d="M6.60461 19.7684C6.60461 20.8244 7.46861 21.6884 8.52461 21.6884H9.91661L6.60461 13.682V19.7684Z" fill="#BDBDBD"/>
</svg>
`;

let customerPortalIcon = `<svg width="27" height="22" viewBox="0 0 27 22" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M21.7391 17.7334C22.9348 17.7334 23.9022 16.7552 23.9022 15.5595L23.913 4.68993C23.913 3.49428 22.9348 2.51602 21.7391 2.51602H4.34783C3.15217 2.51602 2.17391 3.49428 2.17391 4.68993V15.5595C2.17391 16.7552 3.15217 17.7334 4.34783 17.7334H1.08696C0.48913 17.7334 0 18.2225 0 18.8204C0 19.4182 0.48913 19.9073 1.08696 19.9073H25C25.5978 19.9073 26.087 19.4182 26.087 18.8204C26.087 18.2225 25.5978 17.7334 25 17.7334H21.7391ZM5.43478 4.68993H20.6522C21.25 4.68993 21.7391 5.17907 21.7391 5.77689V14.4725C21.7391 15.0704 21.25 15.5595 20.6522 15.5595H5.43478C4.83696 15.5595 4.34783 15.0704 4.34783 14.4725V5.77689C4.34783 5.17907 4.83696 4.68993 5.43478 4.68993Z" fill="#BDBDBD"/>
<path d="M16.3043 13.1139V13.3856C16.3043 12.9532 16.1326 12.5385 15.8268 12.2327C15.521 11.927 15.1063 11.7552 14.6739 11.7552H11.413C10.9806 11.7552 10.5659 11.927 10.2601 12.2327C9.95437 12.5385 9.78259 12.9532 9.78259 13.3856V13.1139" stroke="#BDBDBD" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M13.0435 10.1248C13.944 10.1248 14.674 9.39479 14.674 8.49433C14.674 7.59386 13.944 6.86389 13.0435 6.86389C12.1431 6.86389 11.4131 7.59386 11.4131 8.49433C11.4131 9.39479 12.1431 10.1248 13.0435 10.1248Z" stroke="#BDBDBD" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;

let accountConfigurationIcon = `<svg width="21" height="22" viewBox="0 0 21 22" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_3643_103543)">
<path d="M3.5 18.875V12.75" stroke="#BDBDBD" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M3.5 9.25V3.125" stroke="#BDBDBD" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M10.5 18.875V11" stroke="#BDBDBD" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M10.5 7.5V3.125" stroke="#BDBDBD" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M17.5 18.875V14.5" stroke="#BDBDBD" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M17.5 11V3.125" stroke="#BDBDBD" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M0.875 12.75H6.125" stroke="#BDBDBD" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M7.875 7.5H13.125" stroke="#BDBDBD" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M14.875 14.5H20.125" stroke="#BDBDBD" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</g>
<defs>
<clipPath id="clip0_3643_103543">
<rect width="21" height="21" fill="white" transform="translate(0 0.5)"/>
</clipPath>
</defs>
</svg>
`;

let integrationIcon = `<svg width="18" height="21" viewBox="0 0 18 21" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8 13.5121L5.83 11.3421L8 9.17208L6.59 7.75208L3 11.3421L6.59 14.9321L8 13.5121Z" fill="#BDBDBD"/>
<path d="M11.41 14.9321L15 11.3421L11.41 7.75208L10 9.17208L12.17 11.3421L10 13.5121L11.41 14.9321Z" fill="#BDBDBD"/>
<path d="M16 2.3421H11.82C11.4 1.1821 10.3 0.342102 9 0.342102C7.7 0.342102 6.6 1.1821 6.18 2.3421H2C1.86 2.3421 1.73 2.3521 1.6 2.3821C1.21 2.4621 0.86 2.6621 0.59 2.9321C0.41 3.1121 0.26 3.3321 0.16 3.5721C0.0600001 3.8021 0 4.0621 0 4.3421V14.3421V15.3421V18.3421C0 18.6121 0.0600001 18.8821 0.16 19.1221C0.26 19.3621 0.41 19.5721 0.59 19.7621C0.86 20.0321 1.21 20.2321 1.6 20.3121C1.73 20.3321 1.86 20.3421 2 20.3421H16C17.1 20.3421 18 19.4421 18 18.3421V15.3421V14.3421V4.3421C18 3.2421 17.1 2.3421 16 2.3421ZM9 2.0921C9.41 2.0921 9.75 2.4321 9.75 2.8421C9.75 3.2521 9.41 3.5921 9 3.5921C8.59 3.5921 8.25 3.2521 8.25 2.8421C8.25 2.4321 8.59 2.0921 9 2.0921ZM16 14.3421V15.3421V18.3421H2V15.3421V14.3421V4.3421H16V14.3421Z" fill="#BDBDBD"/>
</svg>
`;

export const settingsList = (data) => {
  return [
    {
      title: "Payment & funding requests",
      icon: paymentRequestIcon,
      display: true,
      sub: [
        {
          title: "Templates & hosted payment pages",
          route: "payment-request-template",
          desc: "Manage templates for payment requests & hosted payment page",
          display: true,
        },
        {
          title: "Default branding & contact details",
          route: "contact-details",
          desc: "Manage default branding & contact details applied to payment pages",
          display: true,
        },
      ],
    },
    {
      title: "Hosted payment pages",
      icon: hostedPaymentPgeIcon,
      display: false,
      sub: [
        {
          title: "Pages",
          route: "hosted-page",
          desc: "View, edit and create pages",
          display: true,
        },
        {
          title: "Default communications settings",
          route: "hosted-page-communication",
          desc: "Set sender & support contact details",
          display: true,
        },
      ],
    },
    {
      title: "Access & permissions",
      icon: accessPermissionCardIcon,
      display: true,
      sub: [
        {
          title: "Users",
          route: "partner-users",
          desc: "View, edit and create users",
          display: true,
        },
        {
          title: "Integrations",
          route: "integrations",
          desc: "Manage API tokens, linked systems",
          display: true,
        },
      ],
    },
    {
      title: "Account configuration",
      icon: accountConfigurationIcon,
      display: true,
      sub: [
        {
          title: "My bank accounts",
          route: "bank-accounts",
          desc: "View accounts, set display names",
          display: true,
        },
        {
          title: `${process.env.VUE_APP_NAME == "RelloPay" ? "Rello" : "FlipPay"} bank details`,
          route: "platform-bank-accounts",
          desc: "View accounts, set display names",
          display: true,
        },
        {
          title: "Finance options",
          route: "merchant-product-list",
          desc: "View available finance options",
          display: data.requestOptions.includes("pay-later") ? true : false,
        },
        {
          title: "Saved external accounts",
          route: "saved-external-accounts",
          desc: "Manage external accounts",
          display: displaySavedExternalAccount(data),
        },
        {
          title: "Archived data",
          route: "archived-data",
          desc: "View archived onboarding data",
          display: data.hasOwnProperty('onboardingId') && data.onboardingId.length > 0 ? true : false,
        },
        {
          title: "Key contacts",
          route: "key-contacts",
          desc: "View contact information",
          display: true,
        },
        {
          title: "Payment services",
          route: "payment-services",
          desc: "View settings for your card & EFT payments",
          display: data.requestOptions.includes("pay-now") ? true : false,
        },
      ],
    }
  ];
};

const displaySavedExternalAccount = (data) => {
  return data.payLaterPlans.some(item => item.planId.disburseTo == "external" && (item.planId.editDisbursement && item.planId.editDisbursement.merchant));
}

